import WithBackground from './WithBackground';

export default WithBackground;
